import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/functions';
import _ from 'lodash';
import { C } from '../constants';
import * as hlp from '../utils/helpers';
import { deleteUser } from './users';

const usersRef = C.DB.ref('users');
const groupsRef = C.DB.ref('groups');
const orgsRef = C.DB.ref('organizations');
const custRef = C.DB.ref('customers');
const assessRef = C.DB.ref('assessments');
const provisional = C.DB.ref('provisional');
const addUserAuth = C.AU_APP.auth();
const storage = firebase.storage();
const functions = firebase.functions();
const utilRef = C.DB.ref('util');

const dbPrfxs = {
    initialized: false
}

function getDbs() {
    if (!dbPrfxs.initialized) {
        for (var i = 2016; i < 2026; i++) {

            dbPrfxs[i + '-a'] = true;
            dbPrfxs[i + '-b'] = true;
        }

        dbPrfxs['overflow'] = true;

        dbPrfxs['invalid'] = true;

        dbPrfxs['main'] = true;

        
        dbPrfxs.initialized = true;
    }
    return dbPrfxs;
}

/*
*UTILS functions
*/

export const parseFullname = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            //for each user, parse the fullname to get first and last names
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                if(!user.firstname && !user.lastname) {
                        let fullname = user.fullname.split(" ");

                        // update the first and last name
                        usersRef.child(childSnap.key).update({
                            "firstname": fullname[0],
                            "lastname": fullname[fullname.length -1]
                        });
                }
            });
            prodConsole.log("users have been updated to contain firstname and lastname fields");
        });
    }
};

export const addLastAssessment = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            const lastAssessment = {lastAssessment: 0}
            //for each user, check if lastAssessment exists and add one if it doesn't exist
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                if(!user.lastAssessment) {
                        usersRef.child(childSnap.key).update(lastAssessment);
                }
            });
            prodConsole.log("users have been updated to contain lastAssessment field");
        });
    }
};

export const addLastAssessmentIDAndRisk = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => {
            let scoredData;

            //for each user, check if lastAssessmentId exists and add one if it doesn't exist
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                let aid = hlp.getLatestAssessment(user);
                
                if (user.assessments) {
                    assessRef.child(aid).once('value', (assessSnap) => {
                        scoredData = hlp.scoreDriveResults(assessSnap.val());
                        const risk = {risk: scoredData.results.danger};
                        usersRef.child(childSnap.key).update(risk);
                    })
                    const lastAssessmentID = {lastAssessmentId: aid};
                    usersRef.child(childSnap.key).update(lastAssessmentID);
                }
            });
            prodConsole.log("users have been updated to contain lastAssessmentId and risk field");
        });
    }
};

export const addLastTime= function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            // const lastAssessment = {lastTime: 0}
            
            //for each user, check if lastAssessment exists and add one if it doesn't exist
            snap.forEach((childSnap) => {
                var lastTime = {lastTime: null};
                let user = childSnap.val();
                if(user.lastAssesment && user.lastAssesment.start) {
                    lastTime = {lastTime: user.lastAssesment.start}
                } else if(typeof user.lastAssessment === 'number') {
                    lastTime = {lastTime: user.lastAssessment}
                } else {
                    prodConsole.log("********no lastAssesment.start or lastAssessment to populate from******");
                }

                if(!user.lastTime && lastTime) {
                        usersRef.child(childSnap.key).update(lastTime);
                }
            });
            prodConsole.log("users have been updated to contain lastTime field if there was data to populate from");
        });
    }
};

export const addDateAdded = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            const dateAdded = {dateAdded: 0}
            //for each user, check if dateAdded exists and add one if it doesn't exist
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                if(!user.dateAdded) {
                        usersRef.child(childSnap.key).update(dateAdded);
                }
            });
            prodConsole.log("users have been updated to contain dateAdded field");
        });
    }
};

export const addRisk = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            const risk = {risk: -2}

            snap.forEach((childSnap) => {
                let user = childSnap.val();
                if(!user.assessments) {
                        usersRef.child(childSnap.key).update(risk);
                }
            });
            prodConsole.log("users who have no assessments now have risk = -2");
        });
    }
};

export const addCorrectLastAssessmentInfo= function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            //get the aid for each user's latest assessment
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                let aid = hlp.getLatestAssessment(user);

                //if this user does have a latest assessment, let's look at it
                if (aid) { 
                    //go through the list of assessments and find this user's latest
                    assessRef.once('value').then((grandSnap) => {
                        for (var assess in grandSnap.val()) {
                            if (aid == assess) {
                                //assess is the user's latest assessment, so assign its start time to user.lastAssessment
                                if (grandSnap.val()[assess].start) {
                                    let lastAssessment = {lastAssessment: grandSnap.val()[assess].start}
                                } else {
                                    let lastAssessment = {lastAssessment: Date.now()}
                                }
                                usersRef.child(childSnap.key).update(lastAssessment);  
                            }
                        }
                    })
                }
                
            });
            prodConsole.log("users' lastAssessment data has been populated with their latest assessment's start time");
        });
    }
};

export const stringToInt = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            //for each user, check if this thing is a string
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                const dateAdded = {dateAdded: parseInt(user.dateAdded)}
                if (user.dateAdded) {
                    if((typeof(user.dateAdded)) === 'string') {
                            usersRef.child(childSnap.key).update(dateAdded);
                    }
                }
            });
            prodConsole.log("users' dateAdded attribute has been turned from a string to an int");
        });
    }
};

export const addNameFields = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            let i=1;
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                const names = {"fullname": i + "fullname",
                                        "lastname": i + "last name",
                                        "firstname": i + "firstname"
                                        }
                i++;
                if(!user.fullname && !user.firstname && !user.lastname) {
                        usersRef.child(childSnap.key).update(names);
                }
            });
            prodConsole.log("users have been updated to contain name fields");
        });
    }
};

export const namesToUpperCase = function () { //TODO
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                let firstname, lastname;
                if (user.firstname) {
                    firstname = user.firstname[0].toUpperCase() + user.firstname.substr(1);
                }
                if (user.lastname) {
                    lastname = user.lastname[0].toUpperCase() + user.lastname.substr(1);
                }

                const names = {"firstname": firstname,
                                        "lastname": lastname,
                                        "fullname": firstname + " " + lastname
                                        }
                if (childSnap.key != "replays") {
                    usersRef.child(childSnap.key).update(names);
                }
            });
            prodConsole.log("users names have been capitalized");
        });
    }
};

export const eraseFields = function () {
    //can specify which field to erase here. In this example, i want to erase "lastAsessment" on the first level under the UID
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            const erase = {lastAssessment: {}}
            snap.forEach((childSnap) => {
                let user = childSnap.val();
                if(user.lastAssessment) {
                        usersRef.child(childSnap.key).update(erase);
                }
            });
            prodConsole.log("'lastAssessment' field erased on all users");
        });
    }
};


export const addFieldFromList = function () {
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => { 
            //our object of key:values to parse
            let p={"0APzki77zMQQA1HqEuX6Mz35LIq1":"flaura@mail.med.upenn.edu","2HZpz2cY8eXgSvKifEGUOxH9HlB2":"dmurph@sas.upenn.edu","3kiYcWQ1yHXCDQvrbCKKb95STuG3":"name@anyformat.com","4Gifn4NcnQfnGbDXzYupF8ogh9E2":"takealuke@gmail.com","5Ig3l0JixCfyFBZlhLZyg6QfgPx1":"luke+4@gmail.com","5vG1t99w4YPZbPW2jrJih8p2e5i1":"metricstesta7@gmail.com","6CeMod1DeohCn7B2jDYBc9iOhDq1":"batman@batcave.com","6q8DiLlcj2NOszBltTIkFRqKkXE3":"montana+mgr@diagnosticdriving.com","7xrbxIAyv8R8m1IMPft9pYEEXrH3":"metricstesta8@gmail.com","8FHM465yS9fEAHcGehFcCMEpOO03":"whitney@zoomer.io","9Cz8kr3pJ2g37xzpjfWW1WU7qaJ2":"luke+driver@diagnosticdriving.com","9h0DqqW1EySDa1pObMARRBfXU0V2":"choo@choo.com","B0eUPqZAjENWSpalkxuqo3FxM1W2":"luke+762@diagnosticdriving.com","BJ9kNxOwo5gMe6VlXqqeqZKFUFP2":"jerry@jerry.com","Bjzh6PZpKrQKkwg1n8PRXq3D47u1":"loo@spyew.com","DF7y7QwchXdkqSAGMv1SVALt6O13":"fitzgeraldp@email.chop.edu","DJMQhyKScmWHle9bDMtt5NJgSyu2":"ryan.siebert@comed.com","FpzS85hNBnWbAKQqjEsOl4rTD8I2":"metricstesta6@gmail.com","HmPRqNjROPRsZ1YI0XsfkCexyQN2":"ch@ch.com","IJBS23PZN0XAz5hwZu2wNdFfWmI3":"test1234@test.com","JfxwG1ZVd7NQFbq0BSJ0N8S3Xi63":"dave@dave.com","K58i9sajvBdLgZETy5rvPeFUAxB2":"person@place.noun","KUyNXIfScIS610Kkd83StfCjQfj2":"a@te.com","KYGRoAhKT0h7Zdqiy6cMQqBNhGJ3":"metricstesta4@gmail.com","L6b2AO5BJ8SjUVJ3xskRa1lmXUO2":"chelsea.ward18@gmail.com","L8MVPkZi0AfB3GbR1AmW6mXFZAA3":"metricstesta1@gmail.com","LLLlfNYAFuSOQKY5nlyMeABZpil1":"elizabeth.kneeland@uphs.upenn.edu","MTwPvDyDJwafEPykqD1eHjpwqdx1":"luke+3@gmail.com","N0nhBQpsoiMaG84RycFOOHPxfHh2":"camden.segal@gmail.com","N7dsQ04zhqhnJswlk6kPE4xqDbn1":"peter.flores@comed.com","NEWL950o2NaAzLoo1vstyruiSiu1":"biff@biff.com","NKUTC9JYntcDzRDtn7xNLnxbXyf1":"choo@choochoo.com","PvepnfCzO5bUxbb7htxsXykZwCe2":"marty@backtothefuture.com","QKvY3tkt5Ub0tABQKO6NI1BH8p63":"habbas@seas.upenn.edu","Qb35Ei1mKkNcy3ymeV9eyGy1dUu2":"tad@pole.com","QpS10lYJ8ld1gWEj5c3rbmePL9v2":"test1@test.com","QsN15ZPx87cBxMwIPZTCjspmcwo1":"felix@thecat.com","QwvXxGBTThQPxdSRmW17WA23XWI2":"joe@joe.com","RaC4tLBpGygeoXLMBOdFeW60g8D2":"david.granger@nsc.org","T8kk6URYIohQ8ZD7XjsDAf07tg03":"s@f.com","TbX85gbfO1bRLc7JvepCnDCLxyy2":"ziaihoum@einstein.edu","U70JN3jSCebmIA5W8cWIj3eZ5M82":"metricstesta5@gmail.com","U8WiVJ8Y6je5qwbfH7QBxTvZgfr1":"leia@rebels.com","Wspss8xYseQipQB5QEQy2bWhVKj2":"test4@test.com","X1W5l1RkV4Rn503DzYJW8ktaNaD3":"these@kids.coms","XS4bOg3uzfcQWclEpI4f6Wo5LAF3":"luke+429@diagnosticdriving.com","Z2KDhoEBSqW16JLmsyDsgmppfKP2":"lynn@diagnosticdriving.com","bicHbOsb26XEai05SksOKmrUznc2":"takealuke+765@gmail.com","c9NpQ6pAH1aqmWenOn9f6YXtdrI3":"logan@xmen.com","c9OziaBBBnZR4I4L3z0ItxUg3093":"willis.391@buckeyemail.osu.edu","cO1BtJDAGXU3krbf3KIuBWuMcqD2":"jeff.kraft@nsc.org","cq59rrOpX6dA5wO0hx4CbD3GNn33":"montana+spr@diagnosticdriving.com","dBZMXsethMSShTny7tdNzh1MnC02":"camden@diagnosticdriving.com","dVQ76ilv3fSlc5L0MeGOMzJ5hvp1":"kurt.weissenhofer@comed.com","emBPq1lzR4dumQXtJfWYeD8Zk8U2":"willis.391@osu.edu","f4fJYpXdSvRng9s3Lr23rqaKBof2":"eduardo.suarez@comed.com","fQaYhksOVcRtvtGxOItXvWMTmmz2":"fred@simeonemuseum.or","fWPpetH5MWhGHNP2ci9LPg768Fl2":"luke@diagnosticdriving.com","fWh87J5VlSfn0rOhgWukWKYg4Iz1":"marvin.landeros@comed.com","fmBeVFJbqAR5BXOSU3e3Q8Fb3I92":"doneill@tcd.ie","gK5f78aKEHRoqoL7NbAgqgVxuI52":"montana@diagnosticdriving.com","geZ5SfmIxIMI4A2QPkQ0igWIfCg1":"mike@mike.com","hJfUX6fAG9e3tUf9kgMAgTlxZWT2":"carolyn@zoomer.io","heLCftiVqjhsCILcI49t7jNFXHR2":"metricstesta3@gmail.com","hmUnud0NDRbV9S3T5Q88z8f6gll2":"stevie@whocares.com","iT2q2ZKuf1SiBOycB8ZYFwCkKar1":"donald.knox@comed.com","iWwvTESjNmTXqBynxevqihu8AYH3":"dbryan@dps.ohio.gov","j49lrA1J0AZaXeOWJ5eKxPx76MH2":"luke+mgr@diagnosticdriving.com","jnB8bYGXMlUVAaWYTanPoU6koWq1":"boo@boo.com","k0zlbK84QXVjaBTRLfQa0ZlbAq43":"ihatesand@imperialscum.com","kF3P4lKvehWCyaybDP7fpJX28Ne2":"sascha@lahti.com","kgeKOJzUoBfFE3Wf0QxCp9KWG5g2":"shiloh.liberatore@exeloncorp.com","knBwGzIexGOR4nBKP6aXRPldgf83":"luke+54@gmail.com","lGvvQY632SR4xPqz7lKud7CF6kM2":"test3@test.com","mKAJkWGIyJV1yom5Al6OlcGD1v03":"han@solo.com","nBGxEBCR88OzJPwskO2LgcnqHPF2":"wardc8@email.chop.edu","nGmjEzPhAvgNbgY5DRPOMnyx45j1":"delete@me.com","nYQJBGrY6QcOXAimZyQ2Eaht7jr1":"bert@ernie.com","ngWCspYx9rSnETHeEgewlIyjvUs2":"venk@somewhere.com","oUTcsfAyCBcI2md2ZHJrF5bxPkT2":"rodionova.alv@gmail.com","pLUrUMYMEmRVbTDxsgNvs4U6Csk2":"b@b.com","pQ5D5LTCuzgnvYXeYAq4dfnOokk2":"lisa.jurado@comed.com","pm6FrVuwATVGi7PXwQ6Xfu89uT03":"metricstesta9@gmail.com","ppypFTsqK4OdxxrnRATYwe85S8r1":"joe@shmoe.com","rII3HcRkgtPotwZgokLiOzcVgE83":"test5@test.com","rTUVl2vyiwfebvpk9hQxLIWerwM2":"thomas.hornicak@comed.com","sXAMWeD7ERalm9zsdKrSTy1JWlA3":"im@adele.com","ta0tii8P4lYBj34ooJdRGGRG01f2":"metricstesta10@gmail.com","uiLb0gNGV3TFhU8eAAlkQYd1U0t2":"lala@test.com","uzvZlUIsrIWzAvtK2NefKgPZi3g1":"rachel@diagnosticdriving.com","vTiizpLblfXwephWndzxLXuCXXt1":"lou@gooey.com","wHTdorbEgOeVSWfGp6d9MfunZLG3":"michaelevanovich@gmail.com","xHebJryy0Jfc6vT60ch5TBlz6sB3":"luke+mukus@diagnosticdriving.com","xdH7ZNdknIeaGNK7dYlxB8wctd32":"metricstesta2@gmail.com","yD6cVlw5iKYc8ryMuhW1N3JKB453":"test2@test.com","yP4JBPyMwDUGeqGiwXu8i7rwPfb2":"chewy@hansolo.com","zL6Hgzx5BmhRmmM9eQR8wqwEMMO2":"venk@diagnosticdriving.com"}
            let newField = {};
            for (var key in p) {
                snap.forEach((childSnap) => {
                    let user = childSnap.val();

                    //match the uid in the list with the uid in the DB
                    if (key === childSnap.key) {
                        newField["email"] = p[key];

                        //update ref
                        if (!user.email) {
                            usersRef.child(childSnap.key).update(newField);
                        }
                    }
                })

            }
            prodConsole.log("users have been updated to contain a new field from some object of key:values");
        });
    }
};

export const matchAssessmentToUser = function () {
    return function (dispatch, getState) {
        assessRef.once('value').then((snap) => {
            snap.forEach((childSnap) => {
                let assessment = childSnap.val();
                let c = {};

                if (assessment.user) {
                    if (assessment.start) {
                        c[childSnap.key] = assessment.start; 
                    } else { //these assessments are still in progress
                        c[childSnap.key] = assessment.initialized;
                    }

                    //push the new assessment to user's assessments list
                    usersRef.child(assessment.user).child("assessments").update(c)
                }
            });
            prodConsole.log("users now have their assessments assigned to them");
        });
    }
};

export const putUsersInTheirGroups = function () {
    return function (dispatch, getState) {
        //drivers
        groupsRef.child("driver/members").once('value').then((snap) => {
            snap.forEach((childSnap) => {
                let group = {"group": "driver"};
                let name = {"fullname": childSnap.val()}

                //update group
                usersRef.child(childSnap.key).update(group);
                //update fullname
                usersRef.child(childSnap.key).update(name)
            });
        });

        //managers
        groupsRef.child("manager/members").once('value').then((snap) => {
            snap.forEach((childSnap) => {
                let group = {"group": "manager"};
                let name = {"fullname": childSnap.val()}

                //update group
                usersRef.child(childSnap.key).update(group);
                //update fullname
                usersRef.child(childSnap.key).update(name)
            });
        });

        //supers
        groupsRef.child("super/members").once('value').then((snap) => {
            snap.forEach((childSnap) => {
                let group = {"group": "super"};
                let name = {"fullname": childSnap.val()}

                //update group
                usersRef.child(childSnap.key).update(group);
                //update fullname
                usersRef.child(childSnap.key).update(name)
            });
        });
    prodConsole.log("users now have their correct group assignments");
    }
};

export const putUsersInTheirOrgs = function () {
    return function (dispatch, getState) {
        orgsRef.once('value').then((snap) => {

            //go through each organization
            snap.forEach((childSnap) => {
                let org = {"organization": childSnap.key};

                //update org
                for (var uid in childSnap.val().members) {
                    usersRef.child(uid).update(org);
                }
            });
        });

    prodConsole.log("users now have their correct organization assignments");
    }
};

export const getFullname = function () {
    //this is sneaky -- we are using the value of the member keys from our list of organizations
    return function (dispatch, getState) {
        orgsRef.once('value').then((snap) => {
            snap.forEach((childSnap) => {
                for (var uid in childSnap.val().members) {
                    let fullname = {"fullname": childSnap.val().members[uid]};
                    usersRef.child(uid).update(fullname);
                }
            });
        });

    prodConsole.log("users now have their correct fullname");
    }
};

export const deleteDisorganizedUsers = function () {
    //this is sneaky -- we are using the value of the member keys from our list of organizations
    return function (dispatch, getState) {
        usersRef.once('value').then((snap) => {
            let x = [];
            let i=1;
            snap.forEach((childSnap) => {
                if(!childSnap.val().email) {
                    prodConsole.log("This user has no email:", childSnap.val().fullname, childSnap.key)
                }
                if (!childSnap.val().organization && !childSnap.val().assessments) {
                    x.push(childSnap.val().email + " : " + childSnap.val().fullname)
                    dispatch(deleteUser(childSnap.key)); 
                } else if (!childSnap.val().organization && childSnap.val().assessments) {
                    prodConsole.log("This user has no organization, but DOES have assessments. They have not been deleted. Assign them an organization plz.", childSnap.val().fullname + " : " + childSnap.val().email + ", UID: ", childSnap.key);
                }
                i++;
            });
        //print their names
        prodConsole.log("The following users were deleted because they had no organization: ", i, x)
        });

    }
};

export const fixReplayUrls = function () {
    return function (dispatch, getState) {
        assessRef.once('value').then((snap) => {

            //go through each organization
            snap.forEach((childSnap) => {

                const assessment = childSnap.val();

                const uid = assessment.user;
                const aid = childSnap.key;

                if (assessment.replay && assessment.replay.url && assessment.replay.ref && uid && aid) {
                        const pathReference = storage.ref(assessment.replay.ref);

                       storage.ref(assessment.replay.ref).getDownloadURL().then((url) => {
                            // `url` is the download URL for 'images/stars.jpg'
                            assessRef.child(aid + "/replay").update({ url }).then( () => { prodConsole.log(aid + " fixed")} );
                        }).catch(function(error) {
                            prodConsole.log("ERROR: " + aid + ": " + error.message);
                        });

                }

            });
        });

    }
};

export const fixOdpsLocations = function () {
    return function (dispatch, getState) {
        assessRef.once('value').then((snap) => {
            snap.forEach((childSnap) => {
                let assessment = childSnap.val();
                let c = {};
                // If assessment does not have a location OR if assessment has incorrect "Mount Vernon" location
                // Set location to Morse Rd. -- leave "Columbus - 1583 Alum Creek Dr., 43209"
                if (!assessment.location || assessment.location == "Mount Vernon - 671 N. Sandusky St., 43050") {
                    assessRef.child(childSnap.key).update({
                            location: "Columbus - 990 Morse Rd., 43229"
                        });
                }
            });
            prodConsole.log("Locations have been fixed.");
        });
    }
}

function shouldBeInBq( assessment, prv ) {
    let valid = true;
    if (assessment.inProgress) {
        valid = false;
    }
    if (!assessment.start && !assessment.trackStart) {
        valid = false;
    }
    if (!assessment.lastUpdate) {
        valid = false;
    }
    if ((prv[assessment.organization] && prv[assessment.organization][assessment.user])) {
        valid = false;
    }

    if (assessment.events) {
        for (var i = 0; i < assessment.events.length; i++) {
            if (!assessment.events[i].name) {
                valid = false;
            }
        };
    }

    

    return valid;
    
}

export const checkAssessmentCounts = function () {
    return function (dispatch, getState) {

        let fetchThese = [];
        fetchThese.push(provisional.once('value'));
        fetchThese.push(assessRef.once('value'));
        fetchThese.push(custRef.once('value'));
        fetchThese.push(usersRef.once('value'));
        fetchThese.push(orgsRef.once('value'));
        Promise.all(fetchThese).then(data => {
            const provisional = data[0];
            const assessments = data[1];
            const customers = data[2].val();
            const users = data[3].val();
            const orgs =data[4].val()
            const prv = provisional.val();

            let results = {};
            results.orgs = {};
            results.orgs.noOrg = {}
            results.orgs.noOrg.abrv = 'NONE';
            results.orgs.noOrg.totalCount = 0;
            results.orgs.noOrg.totalWithEnd = 0;
            results.orgs.noOrg.totalWithoutEnd = 0;
            results.orgs.noOrg.totalWithEndAndInProgress = 0;
            results.orgs.noOrg.totalWithoutEndAndInProgress = 0;
            results.orgs.noOrg.totalWithInProgressTrue = 0;
            results.orgs.noOrg.provisionalCount = 0;
            results.orgs.noOrg.nonProvisionalCount = 0;
            results.orgs.noOrg.validCount = 0;
            results.orgs.noOrg.invalidCount = 0;
            results.orgs.noOrg.assessmentsWithNoStartOrInitialized = 0;
            results.orgs.noOrg.assessmentsWithNoLastUpdate = 0;
            results.orgs.noOrg.alreadyHasBqActiveReady = 0;
            results.orgs.noOrg.assessmentsWithNoUserInfo = 0;
            results.orgs.noOrg.assessmentsWithUserInfo = 0;

            _.map(orgs, (org, orgId) => {
                let orgData = {};
                results.orgs[orgId] = orgData;
                orgData.abrv = org.abrv;
                orgData.totalCount = 0;
                orgData.totalWithEnd = 0;
                orgData.totalWithoutEnd = 0;
                orgData.totalWithEndAndInProgress = 0;
                orgData.totalWithoutEndAndInProgress = 0;
                orgData.totalWithInProgressTrue = 0;
                orgData.provisionalCount = 0;
                orgData.nonProvisionalCount = 0;
                orgData.validCount = 0;
                orgData.invalidCount = 0;
                orgData.assessmentsWithNoStartOrInitialized = 0;
                orgData.assessmentsWithNoLastUpdate = 0;
                orgData.alreadyHasBqActiveReady = 0;
                orgData.assessmentsWithNoUserInfo = 0;
                orgData.assessmentsWithUserInfo = 0;
            })

            results.totalCount = 0;
            results.totalWithEnd = 0;
            results.totalWithoutEnd = 0;
            results.totalWithEndAndInProgress = 0;
            results.totalWithoutEndAndInProgress = 0;
            results.totalWithInProgressTrue = 0;
            results.provisionalCount = 0;
            results.nonProvisionalCount = 0;
            results.validCount = 0;
            results.invalidCount = 0;
            results.assessmentsWithNoStartOrInitialized = 0;
            results.assessmentsWithNoLastUpdate = 0;
            results.alreadyHasBqActiveReady = 0;
            results.assessmentsWithNoUserInfo = 0;
            results.assessmentsWithUserInfo = 0;
            results.shouldBeInBq = 0;
            results.listOfAssessmentsWithoutUserInfo = [];

            assessments.forEach(childSnap => {
                let assessment = childSnap.val();
                let aid = childSnap.key;

                results.totalCount += 1;
                let orgKey = assessment.organization || 'noOrg';
                results.orgs[orgKey].totalCount += 1;

                if (shouldBeInBq(assessment, prv)) {
                    results.shouldBeInBq += 1;
                }

                if (assessment.end) {
                    results.totalWithEnd += 1;
                    results.orgs[orgKey].totalWithEnd += 1;

                    if (assessment.inProgress) {
                        results.totalWithEndAndInProgress += 1;
                        results.orgs[orgKey].totalWithEndAndInProgress += 1;
                    }
                } else {
                    results.totalWithoutEnd += 1;
                    results.orgs[orgKey].totalWithoutEnd += 1;
                    if (assessment.inProgress) {
                        results.totalWithoutEndAndInProgress += 1;
                        results.orgs[orgKey].totalWithoutEndAndInProgress += 1;
                    }
                }

                let valid = true;

                if (prv[assessment.user] || (prv[assessment.organization] && prv[assessment.organization][assessment.user])) {
                    results.provisionalCount += 1;
                    results.orgs[orgKey].provisionalCount += 1;
                    valid = false;
                } else {
                    results.nonProvisionalCount += 1;
                    results.orgs[orgKey].nonProvisionalCount += 1;
                }

                if (assessment.bqActiveReady) {
                    results.alreadyHasBqActiveReady += 1;
                    results.orgs[orgKey].alreadyHasBqActiveReady += 1;
                    valid = false;
                }

                if (assessment.inProgress) {
                    results.totalWithInProgressTrue += 1;
                    results.orgs[orgKey].totalWithInProgressTrue += 1;
                    valid = false;
                }

                if (!(assessment.start || assessment.initialized)) {
                    results.assessmentsWithNoStartOrInitialized += 1;
                    results.orgs[orgKey].assessmentsWithNoStartOrInitialized += 1;
                    valid = false;
                }

                if (!assessment.lastUpdate) {
                    results.assessmentsWithNoLastUpdate += 1;
                    results.orgs[orgKey].assessmentsWithNoLastUpdate += 1;
                    valid = false;
                }
                let rootCustomer = customers[assessment.user];
                let customer = customers[assessment.organization] && customers[assessment.organization][assessment.user];

                let possibleOwner = (customer && customer.addedBy) || (rootCustomer && rootCustomer.addedBy);
                let user = users[assessment.user];
                let manager = users[possibleOwner];

                if (user || manager) {
                    results.assessmentsWithUserInfo += 1;
                    results.orgs[orgKey].assessmentsWithUserInfo += 1;
                } else {
                    results.assessmentsWithNoUserInfo += 1;
                    results.orgs[orgKey].assessmentsWithNoUserInfo += 1;
                    results.listOfAssessmentsWithoutUserInfo.push({aid, user, manager, auser : assessment.user});
                    //NBB: NOT INVALIDATING we're adding the assessments in bigQuery with missing user info
                }

                if (!valid) {
                    results.invalidCount += 1;
                    results.orgs[orgKey].invalidCount += 1;
                } else {
                    results.validCount += 1;
                    results.orgs[orgKey].validCount += 1;
                }

            });

            let copyResults = Object.assign({}, results);
            delete copyResults.listOfAssessmentsWithoutUserInfo;
            dispatch({type: C.SET_COUNT_DATA, data: copyResults});

            window.downloadAssessmentCounts = function () {
                let data = JSON.stringify(results, undefined, 4);
                let blob = new Blob([data], {type: 'text/json'}),
                    e    = document.createEvent('MouseEvents'),
                    a    = document.createElement('a')

                a.download = "assessmentCounts.json"
                a.href = window.URL.createObjectURL(blob)
                a.dataset.downloadurl =  ['text/json', a.download, a.href].join(':')
                e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
                a.dispatchEvent(e)
            }
            prodConsole.log("Done counting, run: window.downloadAssessmentCounts()");

        })

    }
}


export const repairReplayReferences = function () {
    return function (dispatch, getState) {
        provisional.once("value").then(prvSnap => {
            const prv = prvSnap.val();
            assessRef.once("value").then(function(snap) {

                let results = {};
                results.errors = {};
                results.fixed = [];
                results.totalCount = 0;
                results.provisionalCount = 0;
                results.nonProvisionalCount = 0;
                results.totalReplaysFailed = 0;
                results.nonProvisionalReplaysFailed = 0;
                results.provisionalReplaysFailed = 0;

                snap.forEach(function(childSnap) {
                    

                    let assessment = childSnap.val();


                    let aid = childSnap.key;

                    results.totalCount += 1;
                    if (prv[assessment.user]) {
                        results.provisionalCount += 1;
                    } else {
                        results.nonProvisionalCount += 1;
                    }

                    if (!assessment.replay) {
                        let path = "replays/" + assessment.user + "/" + aid + "/" + aid + ".ddd";
                        let reportFixed = ( (aid) => {return () => { results.fixed.push(aid); } } )(aid);
                        let reportError = ( (aid, assessment) => { return (e) => { 
                            results.errors[aid] = e;
                            results.totalReplaysFailed += 1;
                            if (prv[assessment.user]) {
                                results.provisionalReplaysFailed += 1;
                            } else {
                                results.nonProvisionalReplaysFailed += 1;
                            }
                        } } )(aid, assessment);

                        storage.ref(path).getDownloadURL().then(function(url) {

                            assessRef.child(aid).update({replay: {ref: path, url}}).then(() => {
                                reportFixed();
                            }).catch(function (err) {
                                reportError(err);
                            })
                        }).catch( function (error) {
                            reportError(error);
                        })
                    }
                    
                });

                window.downloadRRResults = function () {
                    let data = JSON.stringify(results, undefined, 4);
                    let blob = new Blob([data], {type: 'text/json'}),
                        e    = document.createEvent('MouseEvents'),
                        a    = document.createElement('a')

                    a.download = "repairReplayReferences.json"
                    a.href = window.URL.createObjectURL(blob)
                    a.dataset.downloadurl =  ['text/json', a.download, a.href].join(':')
                    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
                    a.dispatchEvent(e)
                }
                prodConsole.log("Done triggering fixes for replay references, wait a minute then run: window.downloadRRResults()");

                // if no snap.val().replay()
                // check to see if there is actually a replay file
                // if so -- write the ref and the downloadUrl to the DB
            })


        });
    }
}

function deliverJsonFile(functionName, object, filename, logMsg, opt_consoleFormatting) {
    window[functionName] = function () {
        let data = JSON.stringify(object, undefined, 4);
        let blob = new Blob([data], {type: 'text/json'}),
            e    = document.createEvent('MouseEvents'),
            a    = document.createElement('a')

        a.download = filename + ".json"
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl =  ['text/json', a.download, a.href].join(':')
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
    }
    prodConsole.log(logMsg + "-- run window." + functionName + '() to download debugging file', opt_consoleFormatting);
}

export const initializeAssessmentTable = function (whichDataset) {
    return function (dispatch, getState) {

        let youAreSure = confirm("Are you sure you want to reset the " + whichDataset + " BigQuery Dataset?\nThis will clear all data.");

        if (youAreSure) {
            let resetDB = functions.httpsCallable('resetBigQueryDatabase');
            resetDB({dataset : whichDataset}).then((result) => {
                prodConsole.log("Success - reset the " + whichDataset + " dataset in BigQuery", result);
            }).catch((err) => {
                prodConsole.log("Error resetting the " + whichDataset + " dataset in BigQuery", err);
            });
        } else {
            prodConsole.log("Operation Cancelled, " + whichDataset + " dataset not reset");
        }
        
    }
};

export const removeAddedToActiveFlags = function () {
    return function (dispatch, getState) {

        let youAreSure = confirm("This will remove the flags that keep assessments from being added to BQ more than once. (Do this befopre a reload)");

        if (youAreSure) {
            monitorProgress(dispatch);
            let removeAddedToActiveFlags = functions.httpsCallable('removeAddedToActiveFlags');
            firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {

                removeAddedToActiveFlags({idToken}).then((result) => {
                    
                    prodConsole.log(`addedToActive flag removed from all assessments, now you should reset/reload BQ`);
                }).catch((err) => {
                    prodConsole.log("Error removing flags", err);
                });
            }).catch(function(err) {
                prodConsole.log("Error getting idToken for reset", err);
            });
        } else {
            prodConsole.log("Operation Cancelled, flags not removed");
        }
        
    }
}

export const trimTheFat = function () {
    return function (dispatch, getState) {

        let youAreSure = confirm("This will will remove info from scoreData that is only needed for analysis");

        if (youAreSure) {
            monitorProgress(dispatch);
            let trimTheFat = functions.httpsCallable('trimTheFat');
            firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {

                trimTheFat({idToken}).then((result) => {
                    
                    prodConsole.log(`initiated trimming of the fat`);
                }).catch((err) => {
                    prodConsole.log("Error trimming the fat", err);
                });
            }).catch(function(err) {
                prodConsole.log("Error getting idToken for fat trimming", err);
            });
        } else {
            prodConsole.log("Operation Cancelled, fat not trimmed");
        }
        
    }
}

export const archiveAssessments = function () {
    return function (dispatch, getState) {

        let youAreSure = confirm("This will move all assessments older than six months to archive databases");

        if (youAreSure) {
            monitorProgress(dispatch);
            let archiveAssessmentsNow = functions.httpsCallable('archiveAssessmentsNow');
            firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {

                archiveAssessmentsNow({idToken}).then((result) => {
                    
                    prodConsole.log(`initiated archiving of the assessments`);
                }).catch((err) => {
                    prodConsole.log("Error initiating archiving", err);
                });
            }).catch(function(err) {
                prodConsole.log("Error getting idToken for archiving", err);
            });
        } else {
            prodConsole.log("Operation Cancelled, assessments not archived");
        }
        
    }
}

export const saveAllToJson = function () {
    return function (dispatch, getState) {
        let youAreSure = confirm("Save all assessments as JSON files in storage?");
        if (youAreSure) {
            let saveAllAssessments = functions.httpsCallable('saveAllAssessments');
            firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {

                saveAllAssessments({idToken}).then((result) => {
                    monitorProgress(dispatch);
                    prodConsole.log("Success - save all as JSON initiated", result);
                }).catch((err) => {
                    prodConsole.log("Error saving all as JSON", err);
                });
            }).catch(function(err) {
                prodConsole.log("Error getting idToken for save all as JSON", err);
            });
        }
    }
}

export const resetAndReloadBigQuery = function () {
    return function (dispatch, getState) {

        let youAreSure = confirm("This will reset the BQ active dataset and initiate the reloading of all assessments. This will take a while.");

        if (youAreSure) {
            let resetLoadBQ = functions.httpsCallable('resetAndLoadBQ');
            firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {

                resetLoadBQ({idToken}).then((result) => {
                    monitorProgress(dispatch);
                    prodConsole.log("Success - reset the BQ load initiated", result);
                }).catch((err) => {
                    prodConsole.log("Error resetting and starting BigQuery load", err);
                });
            }).catch(function(err) {
                prodConsole.log("Error getting idToken for reset", err);
            });
        } else {
            prodConsole.log("Operation Cancelled, BQ not reset");
        }
        
    }
};

function monitorProgress(dispatch) {
    //TODO: monitor all DBs
    utilRef.child('lastAssessmentCount').on("value", (data) => {
        if (data.val()) {
            dispatch({ type: C.SET_TOTAL_ASSESSMENTS, total: data.val()});
        }
    });

    C.DB.ref('retroScoring').on("value", (data) => {
        let total = data.val() ? Object.keys(data.val()).length : 0
        dispatch({ type: C.SET_RETRO_SCORING_COUNT, total});
    });

    C.DB.ref('bQueue').on("value", (data) => {
        let total = data.val() ? Object.keys(data.val()).length : 0
        dispatch({ type: C.SET_BQ_LOAD_COUNT, total});
    });

    C.DB.ref('saveAllQueue').on('value', (data) => {
        let total = data.val() ? Object.keys(data.val()).length : 0
        dispatch({ type: C.SET_SAVE_ALL_COUNT, total});
    });

    C.DB.ref('activeFlagRemovalList').on("value", (data) => {
        let total = data.val() ? Object.keys(data.val()).length : 0;
        dispatch({ type: C.SET_FLAG_REMOVE_COUNT, total});
    });

    C.DB.ref('trimTheFat').on("value", (data) => {
        let total = data.val() ? Object.keys(data.val()).length : 0;
        dispatch({ type: C.SET_TRIM_THE_FAT_COUNT, total});
    });

    C.DB.ref('archiveQueue').on("value", (data) => {
        let total = data.val() ? Object.keys(data.val()).length : 0;
        dispatch({ type: C.SET_ARCHIVING_COUNT, total});
    });

}

export const monitorBigTaskProcess = function () {
    return function(dispatch, getState) {
        monitorProgress(dispatch);
    }
}

export const scoreAllAssessments = function () {
    return function (dispatch, getState) {

        let youAreSure = confirm("This initiate scoring and feature creation for all assessments in the system. " +
                                 "It will take a while for all assessments to ultimately be scored. " +
                                 "This deletes and recreates the scoreData table in BQ, then queues all assessments (in main DB) for load.");

        if (youAreSure) {

            monitorProgress(dispatch);

            let scoreAll = functions.httpsCallable('scoreAllAssessments');
            let resetScoringDB = functions.httpsCallable('resetScoringDB');
            firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {

                resetScoringDB().then(res => {
                    prodConsole.log('scoreData table deleted and recreated in BQ');
                    scoreAll({idToken}).then((res) => {
                        prodConsole.log('Assessments queued for scoring', res);
                    }).catch((err) => {
                        prodConsole.log('Error queueing assessments for scoring', err);
                    })
                }).catch(err => {
                    prodConsole.log('Error resetting scoreData table in BQ')
                })



            }).catch(function(err) {
                prodConsole.log("Error getting idToken for bulk scoring", err);
                    });
        } else {
            prodConsole.log("Operation Cancelled, Bulk scoring & feature creation not initiated");
        }

    }
}

export const resetScoreTable = function () {
    return function (dispatch, getState) {

        let youAreSure = confirm("This will delete and re-create the scoreData table in BigQuery.");

        if (youAreSure) {

            let rstScore = functions.httpsCallable('resetScoringDB');
            rstScore().then((result) => {
                prodConsole.log("Success - scoreData table has been reset", result);
            }).catch((err) => {
                prodConsole.log("Error resetting score table", err);
            });
        } else {
            prodConsole.log("Operation Cancelled, scoreTable data left alone.");
        }

    }
}

export const triggerStragglerLoad = function () {
    return function (dispatch, getState) {
        let trgr = functions.httpsCallable('triggerStragglerLoad');
        trgr().then(rslt => {
            alert('Triggered function to load stragglers into BQ');
        })
    }
}

export const triggerBackendFunction = function (fName) {
    return function (dispatch, getState) {
        let trgr = functions.httpsCallable(fName);
        trgr().then(rslt => {
            alert('Triggered backend function ' + fName);
        })
    }
}

export const triggerBackendFunctionWithInput = function (fName) {
    return function (dispatch, getState) {
        let trgr = functions.httpsCallable(fName);
        let userInput = prompt("Enter a value", "luke@diagnosticdriving.com");
        trgr({userInput}).then(rslt => {
            alert('Triggered backend function ' + fName);
        })
    }
}

export const generateScore = function (assessmentId, replayRef) {
    return function (dispatch, getState) {
        let score = functions.httpsCallable('triggerScoring');
        assessRef.child(assessmentId).child('scoreData').set(null).then(() => {
            let scoreRef = assessRef.child(assessmentId).child('scoreData');
            scoreRef.on('value', snap => {
                if (snap.val()) {
                    dispatch({ type: C.END_CALCULATING_SCORE, aid: assessmentId});
                    scoreRef.off();
                }
            })
            dispatch({ type: C.START_CALCULATING_SCORE, aid: assessmentId });
            score({assessmentId, replayRef}).then(result => {
                prodConsole.log(`Score generation seems to have worked for ${assessmentId}, ${replayRef}`, result);
            }).catch(err => {
                prodConsole.log(`Error occured trying to score ${assessmentId}, ${replayRef}`, err);
            })
        })
        
    }
}

export const sendPdf = function (aid) {
    return function (dispatch, getState) {
        let trgr = functions.httpsCallable('sendPdf');
        let userInput = prompt("Enter a value", "luke@diagnosticdriving.com");
        dispatch({ type: C.START_SEND_PDF, aid: aid });
        trgr({userInput, aid}).then(rslt => {
            dispatch({ type: C.END_SEND_PDF, aid: aid});
            alert('Triggered send pdf to ' + userInput + ' for assessment: ' + aid);
        }).catch(err => {
            dispatch({ type: C.ERROR_SEND_PDF, aid: aid});
        })
    }
}

export const clearPdf = function (aid) {
    return function (dispatch, getState) {

        dispatch({ type: C.START_CLEAR_PDF, aid: aid });
        storage.ref().child('pdfFeedback').child(aid + '.pdf').delete().then(() => {
            dispatch({ type: C.END_CLEAR_PDF, aid: aid});
        }).catch((error) => {
            dispatch({ type: C.ERROR_CLEAR_PDF, aid: aid});
        });
        // trgr({userInput, aid}).then(rslt => {
        //     dispatch({ type: C.END_SEND_PDF, aid: aid});
        //     alert('Triggered send pdf to ' + userInput + ' for assessment: ' + aid);
        // }).catch(err => {
        //     dispatch({ type: C.ERROR_SEND_PDF, aid: aid});
        // })
    }
}

export const forceBQ = function (assessmentId) {
    return function (dispatch, getState) {
        let force = functions.httpsCallable('forceAddToBigQuery');

        dispatch({ type: C.START_FORCE_LOAD, aid: assessmentId });
        force({assessmentId}).then(result => {
            dispatch({ type: C.END_FORCE_LOAD, aid: assessmentId});
            prodConsole.log(`Force load seems to have worked for ${assessmentId}`, result);
        }).catch(err => {
            dispatch({ type: C.ERROR_FORCE_LOAD, aid: assessmentId});
            prodConsole.log(`Error occured trying to force load ${assessmentId}`, err);
        })
        
    }
}

export const clearBQDebug = function () {
    return function (dispatch, getState) {


        C.DB.ref('debugLog/bq').set(null).then(() => {
            prodConsole.log("Cleared BQ debug logs");
        });

        
    }
}

export const updateCoachingItemChoices = function () {
    return function (dispatch, getState) {


        C.DB.ref('coachingItems').once("value").then((snap) => {
            let fixes = [];
            _.map(snap.val(), (ci, cid) => {
                if (ci.numberOfChoices && !ci.choices) {
                    
                    let update = {};
                    update.choices = [];
                    for (var i = 0; i < ci.numberOfChoices; i++) {
                        let disKey = "choicedisplay-" + (i + 1);
                        let valKey = "choicevalue-" + (i + 1);
                        update.choices.push({display: ci[disKey], value: ci[valKey]});
                        update[disKey] = null;
                        update[valKey] = null;
                    };

                    fixes.push(C.DB.ref('coachingItems/' + cid).update(update));
                }
            });
            Promise.all(fixes).then(results => {
                prodConsole.log("Fixed all coaching items so that they have an array of choices");
            })
        });

        
    }
}

const triggerMap = {
    active : 'bqActiveReady',
    dormant: 'bqDormantReady'

};

const flagMap = {
    active : 'addedToActive',
    dormant : 'addedToDormant'
};

export const removeAlreadyAddedFlag = function (whichDataset) {
    return function (dispatch, getState) {
        assessRef.once('value').then(snap => {
            const all = snap.val();
            let removes = [];
            let update = {};
            update[flagMap[whichDataset]] = null;
            _.map(all, (a, k) => {

                removes.push(assessRef.child(k).update(update));
            });
            Promise.all(removes).then(results => {
                prodConsole.log(`${flagMap[whichDataset]} property removed from all assessments`);
            })
        })
    }
}

export const loadAllAssessmentsIntoBigQuery = function (whichDataset) {
    return function (dispatch, getState) {

        // Once every hundred mils, 10/s, 600/m, 36000/h
        // Once every 250 mils, 4/s, 240/m, 14400/h
        let waitTime = 250;

        let youAreSure = confirm("Are you sure you want to load all the assessments into the BigQuery " + whichDataset + " dataset?\nMake sure you've reset the table first!");

        if (youAreSure) {
            // bqDormantReady will trigger a load into the dormant dataset
            // bqActiveReady will trigger a load into the activee dataset
            const triggerProp = triggerMap[whichDataset];
            assessRef.once('value').then(snap => {
                const all = snap.val();
                const allArray = _.map(all, (data, aid) => {
                    return aid;
                });

                prodConsole.log("This could take over " + (allArray.length * waitTime) / 60000 + " minutes (if all assessments need to be added to DB)");
                

                let skippedIds = [];
                function process (assessmentIds) {
                    let nextId = assessmentIds.shift();
                    if (nextId) {
                        const alreadyInBigQuery = all[nextId][flagMap[whichDataset]];
                        
                        if (!alreadyInBigQuery) {
                            assessRef.child(nextId + "/" + triggerProp).set(null).then(() => {
                                assessRef.child(nextId + "/" + triggerProp).set(true).then(() => {
                                    prodConsole.log('%c ' + nextId + ' ' + triggerProp, 'color: green;');
                                    setTimeout(() => {
                                        process(assessmentIds);
                                    }, waitTime);
                                });
                            });
                        } else {
                            skippedIds.push(nextId);
                            //need to use setTimeout, otherwise will hit call stack error when the list gets too long
                            setTimeout(() => {
                                process(assessmentIds);
                            }, 5);
                        }
                        
                    } else {
                        prodConsole.log("%c All assessments triggered for load into BQ!", 'color: blue;');
                        prodConsole.log("%c " + skippedIds.length + ' ids skipped', 'color: red;');
                    }
                }

                process(allArray);
            })

        } else {
            prodConsole.log("Operation Cancelled, DB not loaded");
        }
        
    }
};



export const cleanUpUsersDb = function () {
    return function (dispatch, getState) {
        prodConsole.log("Attempting to remove ghost users from DB");
        Promise.all([usersRef.once('value'), custRef.once('value')]).then(snaps => {
            let users = snaps[0].val();
            let customers = snaps[1].val();
            let actions = [];
            let removed = [];
            _.map(users, (user, uid) => {
                if (customers[uid]) {
                    removed.push(uid);
                    actions.push(usersRef.child(uid).set(null));
                } else {
                    if (!(user.fullname && user.group)) {
                        removed.push(uid);
                        actions.push(usersRef.child(uid).set(null));
                    }
                }
            });
            Promise.all(actions).then(results => {
                prodConsole.log("removed invalid users", removed);
            }).catch(err => { prodConsole.error(err) })
        }).catch(err => { prodConsole.error(err) });
        
    }
};

export const createCombinedPropertiesForSortingAndFiltering = function () {
    return (dispatch, getState) => {
        assessRef.once('value').then(snap => {
            let procedures = _.map(snap.val(), (asm, aid) => {
                if (asm.organization) {
                    const endStamp = asm.loginTime || asm.start || asm.trackStart || asm.end || asm.lastUpdate || 175538318; // just use Luke's birthday -- that way you can query for unended if you know the trick
                    return assessRef
                        .child(aid)
                        .update({
                            orgEnd : (asm.organization + endStamp),
                            orgCust : (asm.organization + asm.user),
                            orgCustEnd : (asm.organization + asm.user + endStamp)})
                }
            });

            Promise.all(procedures).then((results) => {
                prodConsole.log('%c All assessments updated with new properties', 'color: green;');
            });
        })
    }
}

export const addOrganizationToAssessments = function () {
    return (dispatch, getState) => {
        let fixedCount = 0;
        let fixed = []
        let alias = window['con' + 'sole'];
        prodConsole.log("Adding organization property to all assessments (that don't have it)");
        Promise.all([assessRef.once('value'), usersRef.once('value'), custRef.once('value'), orgsRef.once('value')]).then(snaps => {
            let assessments = snaps[0].val();
            let users = snaps[1].val();
            let customers = snaps[2].val();
            let orgs = snaps[3].val();

            let dbgr = {};
            dbgr.orgs = orgs;

            let numOfAssessmentsWithOrg = 0;
            let numOfAssessmentsWithoutOrg = 0;
            let needFixing = [];
            dbgr.needFixing = needFixing;

            _.map(assessments, (asm, aid) => {

                if (!asm.organization) {
                    numOfAssessmentsWithoutOrg += 1;
                    let dbg = {};
                    needFixing.push(dbg);
                    let uid = asm.user;
                    dbg.uid = uid;
                    dbg.aid = aid;
                    let found = false;
                    if (customers[uid]) {
                        dbg.cUid = customers[uid];
                        dbg.cUidAddedBy = customers[uid].addedBy;
                        uid = customers[uid].addedBy;
                        found = true;
                    }
                    if (!found) {
                        dbg.orgs = [];
                        for (var oKey in orgs) {
                            dbg.orgs.push(oKey);
                            if (customers[oKey] && customers[oKey][uid]) {
                                dbg.nestedOkeyUid = customers[oKey][uid];
                                dbg.nestedOkeyUidAddedBy = customers[oKey][uid].addedBy;
                                uid = customers[oKey][uid].addedBy;
                            }
                        }
                    }
                    

                    if (uid && users[uid]) {
                        dbg.ultimateUid = users[uid] || 'userNotFound';
                        if (users[uid].organization) {
                            dbg.ultimateOrg = users[uid].organization || 'orgNotFound';
                            fixedCount++;
                            fixed.push(aid);
                            assessRef.child(aid).update({ organization : users[uid].organization }).then(() => {
                                prodConsole.log('%c Passed: ' + aid, 'color: green;')
                            }).catch(err => {
                                prodConsole.log('%c Failed: ' + aid , 'color: red;', err);
                            });
                        } else {
                            prodConsole.log('%c Unable to fix ' + aid + ', user ' + uid + ' does not have an organization set!' , 'color: orange;');
                        }
                        
                    }
                } else {
                    numOfAssessmentsWithOrg += 1;
                }

                

            })
            deliverJsonFile('downloadAddOrgDbg', dbgr, 'addOrgsOutput', '%c Attempted to add organization to ' + fixedCount + ' assessment records', 'color: blue; font-weight: bold;');
        }).catch(err => {
            prodConsole.log("Failed to fetch assessments, users and/or organizations", err)
        });
    }
};

export const setDefaultCitiesOnOrganizations = function () {
    return function (dispatch, getState) {
        prodConsole.log("Attempting to set org cities");
        orgsRef.once('value', (snap) => {
            _.map(snap.val(), (org, oid) => {
                if (!org.cities) {
                    orgsRef.child(oid + '/cities').set([true, true, true, true, true, true, true, true, true, true]);
                }
            });
        });
        
    }
};

export const addSuperDrivers = function () {
    return function (dispatch, getState) {
        // add super drivers to all organizations
        
        orgsRef.once('value').then(snap => {
            let ops = [];
            _.map(snap.val(), (org, oid) => {
                for (var i = 0; i < C.SUPER_DRIVER_IDS.length; i++) {
                    ops.push(custRef.child(oid + '/' + C.SUPER_DRIVER_IDS[i]).transaction(customer => {
                        if (customer === null) {
                            return {
                                added: C.TS,
                                addedBy: getState().auth.uid
                            }
                        }
                    }));
                };
            });
            Promise.all(ops).then(results => {
                prodConsole.log('%c Added Super Driver IDs to all orgs' , 'color: blue;');
                prodConsole.log(results);
            })
        })
    }
}

export const clearGhostUsers = function () {
    return function (dispatch, getState) {
        // add super drivers to all organizations
        
        usersRef.once('value').then(snap => {
            let ops = [];
            let removed = {};
            _.map(snap.val(), (user, userId) => {

                if (!user.email && !user.group) {
                
                    ops.push(usersRef.child(userId).set(null));
                    removed[userId] = user;
                
                }

            });
            Promise.all(ops).then(results => {
                prodConsole.log(`%c Removed ${results.length} ghosts. Boo!` , 'color: blue;');
                prodConsole.log(removed);
            });
        })
    }
}

export const duplicateAssessment = function (asm, aid, options) {
    return function (dispatch, getState) {
        let dupe = functions.httpsCallable('duplicateAssessment');
        options = options || {};
        console.log("calling duplicate assessment backend function", aid, options);
        dupe({asm, aid, options}).then(result => {
            prodConsole.log(`Duplicated ${aid}`, result);
        }).catch(err => {
            prodConsole.log(`Error duplicating ${aid}`, err);
        })
        
    }
}

/*


function deliverJsonFile(functionName, object, filename, logMsg, opt_consoleFormatting) {
    window[functionName] = function () {
        let data = JSON.stringify(object, undefined, 4);
        let blob = new Blob([data], {type: 'text/json'}),
            e    = document.createEvent('MouseEvents'),
            a    = document.createElement('a')

        a.download = filename + ".json"
        a.href = window.URL.createObjectURL(blob)
        a.dataset.downloadurl =  ['text/json', a.download, a.href].join(':')
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(e)
    }
    prodConsole.log(logMsg + "-- run window." + functionName + '() to download debugging file', opt_consoleFormatting);
}


*/


export const downloadSnapshot = function () {
    return function (dispatch, getState) {
        prodConsole.log("Starting to fetch all assessments between July 1 2017 (first second) and March 31 2022 (last second)");
        let oneWeek =  604800000;
        
        
        let weekGrabs = [];
        
        let output = {};
        let finished = 0;
        
        let start = 1498881600000; // July 1 2017 (first second)
        let thisEnd = start + oneWeek;
        let end = 1648742399000; // March 31 2022 (last second)
        
        let spans = [];
        
        while (thisEnd <= end) {
            weekGrabs.push([start, thisEnd]);
            //weekGrabs.push(assessRef.orderByChild('end').startAt(start).endAt(thisEnd).once('value'));
            start = start + oneWeek;
            if (thisEnd == end) {
                thisEnd = thisEnd + oneWeek;
            } else {
                thisEnd = Math.min(thisEnd + oneWeek, end);
            }
        }
        prodConsole.log("how many grabs?", weekGrabs.length, spans);
        
        let finish = function () {
            prodConsole.log("finished " + finished + " of " + weekGrabs.length);
            if (finished >= weekGrabs.length) {
                console.log(output);
                deliverJsonFile("gimme", output, "allJuly2017ToMArch2022", "Ready to call gimme()");
            }
        }
        
        let makeFetchFunction = function (start, end) {
            return function () {
                assessRef.orderByChild('end').startAt(start).endAt(end).once('value').then(snap => {
                    _.map(snap.val(), (val, aid) => {
                        output[aid] = val.end
                    })
                    //output = Object.assign(output, snap.val());
                    finished++;
                    finish();
                })
            }
        }
        
        for (var i = 0; i < weekGrabs.length; i++) {
            
            setTimeout(makeFetchFunction(weekGrabs[i][0], weekGrabs[i][1]), 1000)

        }
        
        // Promise.all(weekGrabs).then(snaps => {
        //     for (var i = 0; i < snaps.length; i++) {
        //         output = Object.assign(output, snaps[i].val());
        //     };
        //     deliverJsonFile("gimme", output, "allJuly2017ToMArch2022", "Ready to call gimme()");
        // })
        

        
//         let fetch = functions.httpsCallable('getAssessmentSnapshot');
// 
//         console.log("getting assessment snapshot");
//         fetch().then(result => {
//             
//             prodConsole.log("Got it");
//             
//             let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(result));
//             let downloadAnchorNode = document.createElement('a');
//             downloadAnchorNode.setAttribute("href",     dataStr);
//             downloadAnchorNode.setAttribute("download", "snapshot.json");
//             document.body.appendChild(downloadAnchorNode); // required for firefox
//             downloadAnchorNode.click();
//             downloadAnchorNode.remove();
//             
//         }).catch(err => {
//             prodConsole.log("Error getting snapshot", err);
//         })
        
    }
}

export const dbDbug = (obj) => {
    C.APP.database().ref('dbgr').set(obj);
}

export const testSubmitIntake = function () {
    return function (dispatch, getState) {
        let sbmt = functions.httpsCallable('submitIntake');
        let testIntakeData= {
            ids : {
                assessmentId : 'testFdbkRisk'
            },
            responses : {
                single : {
                    "name>>first" : "Luke",
                    "name>>last" : "Skywalker"
                },

                choice : {
                    "goals>>goals" : {
                        "_1" : true,
                        "_5" : true 
                    }
                }
            }
        }
        console.log("calling submitIntake backend function", testIntakeData);
        sbmt(testIntakeData).then(result => {
            prodConsole.log(`Called submit intake function`, result);
        }).catch(err => {
            prodConsole.log(`Error calling submitIntake`, err);
        })
    }
}

export const findWhoHasDataAccess = function () {
    return function (dispatch, getState) {
        let list = [];
        usersRef.once('value').then(uSnap => {
             _.map(uSnap.val(), (user, userId) => {

                if (user.features && user.features.data) {
                    list.push(user.email);
                }

            });
            prodConsole.log(list);
        })
    }
}

export const exposeFirebase = function() {
    return function (dispatch, getState) {
        window.fbdb = C.DB;
    }
}

export const logBrowserInfo = function(label) {

    return function (dispatch, getState) {
        let nVer = navigator.appVersion;
        let nAgt = navigator.userAgent;
        let browserName  = navigator.appName;
        let fullVersion  = ''+parseFloat(navigator.appVersion); 
        let majorVersion = parseInt(navigator.appVersion,10);
        let nameOffset,verOffset,ix;

        // In Opera, the true version is after "Opera" or after "Version"
        if ( (verOffset=nAgt.indexOf("Opera") ) != -1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset+6);
            if ((verOffset=nAgt.indexOf("Version"))!=-1) 
                fullVersion = nAgt.substring(verOffset+8);
        }
            // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
            browserName = "Microsoft Internet Explorer";
            fullVersion = nAgt.substring(verOffset+5);
        }
            // In Chrome, the true version is after "Chrome" 
        else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
            browserName = "Chrome";
            fullVersion = nAgt.substring(verOffset+7);
        }
            // In Safari, the true version is after "Safari" or after "Version" 
        else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
            browserName = "Safari";
            fullVersion = nAgt.substring(verOffset+7);
            if ((verOffset=nAgt.indexOf("Version"))!=-1) 
                fullVersion = nAgt.substring(verOffset+8);
        }
                // In Firefox, the true version is after "Firefox" 
        else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
            browserName = "Firefox";
            fullVersion = nAgt.substring(verOffset+8);
        }
        // In most other browsers, "name/version" is at the end of userAgent 
        else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < 
                  (verOffset=nAgt.lastIndexOf('/')) ) 
        {
            browserName = nAgt.substring(nameOffset,verOffset);
            fullVersion = nAgt.substring(verOffset+1);
            if (browserName.toLowerCase()==browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix=fullVersion.indexOf(";"))!=-1)
           fullVersion=fullVersion.substring(0,ix);
        if ((ix=fullVersion.indexOf(" "))!=-1)
           fullVersion=fullVersion.substring(0,ix);

        majorVersion = parseInt(''+fullVersion,10);
        if (isNaN(majorVersion)) {
            fullVersion  = ''+parseFloat(navigator.appVersion); 
            majorVersion = parseInt(navigator.appVersion,10);
        }


        let logData = {
            when: C.TS,
            label,
            browserName,
            fullVersion,
            majorVersion,
            navAppName: navigator.appName,
            navUserAgent: navigator.userAgent,
            appVersion: navigator.appVersion
        }

        C.DB.ref('debugLog/browserInfo').push(logData);
    }
    
    

}

export const startListeningToJsonEdit = function(path) {
    return function (dispatch, getState) {
        dispatch({ type: C.RESET_JSON_EDIT_DATA});
        console.log('debug startListeningToJsonEdit');
        let ref = C.DB.ref(path);
        ref.on("value", (snap) => {
            console.log('JSON to edit', snap.val());
            dispatch({ type: C.RECEIVE_JSON_EDIT_DATA, data: snap.val()});
        })
    }
}

